import React from "react";
import heart from "../../../Assets/heart.png";
import { showAlert } from "../../../feedback/feedbackApi";

export default function GeneralSurgerySection() {

  const handleClick = () => {
    showAlert("Button clicked.", { variant: "success" });
  };

  return (
    <div className="ortho-section">
      <div className="container-1440">
        {/* Heading */}
        <h1>
          Learn About <span>General Surgery</span>
        </h1>
        <p className="subtitle">
          Read the details below to understand more about General Surgery
          and choose the right treatment confidently.
        </p>

        {/* Top Image */}
        <div className="top-img">
          <img src={heart} alt="ortho" />
        </div>

        <h3 className="what-title">What is General Surgery?</h3>
        <p className="desc">
          General surgery focuses on treating conditions related to the abdomen,
          digestive tract, skin, soft tissues and more. It includes both minor
          and major surgical procedures to improve health and quality of life.
        </p>

        {/* Cards */}
        <div className="cards">

          {/* Card 1 */}
          <div className="card">
            <h4>Conditions Commonly Treated</h4>
            <ul>
              <li>Appendix problems</li>
              <li>Hernia</li>
              <li>Gallbladder stones</li>
              <li>Piles & fissure</li>
              <li>Breast lumps</li>
              <li>Thyroid issues</li>
            </ul>
          </div>

          {/* Card 2 */}
          <div className="card active">
            <h4>Treatment Options</h4>
            <ul>
              <li>Laparoscopic surgery</li>
              <li>Laser surgery</li>
              <li>Open surgery</li>
              <li>Medication & care</li>
              <li>Daycare procedures</li>
            </ul>
          </div>

          {/* Card 3 */}
          <div className="card">
            <h4>Benefits of Treatment</h4>
            <ul>
              <li>Fast recovery</li>
              <li>Minimal pain</li>
              <li>Safe procedures</li>
              <li>Experienced surgeons</li>
              <li>Affordable packages</li>
            </ul>
          </div>

        </div>

        {/* Button */}
        <button className="continue-btn" onClick={handleClick}>
          Continue to Set Budget
        </button>

      </div>
    </div>
  );
}
